module.exports = __webpack_public_path__ + "static/media/background1.05953ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background1.jpg
// module id = 319
// module chunks = 0